export default function About() {

  return (

    <div className="container-narrow">

      <div className="card">

        <h1>About Hopeful Horizons NY</h1>

        <p>

          Hopeful Horizons NY is an online directory designed to help individuals and families connect with qualified Direct Support Professionals (DSPs) who provide OPWDD services across New York State.

        </p>

        <p>

          Our mission is to make it easier for families to find reliable support for Community Habilitation, Respite, and other services that promote independence, skill development, and community participation.

        </p>

        <p>

          We understand that finding the right provider is an important decision. Hopeful Horizons NY allows families to review provider experience, certifications, availability, and contact information in one centralized location.

        </p>

        <p>

          Our platform is designed to support collaboration between families, self-directed participants, care managers, and providers to improve access to quality services.

        </p>

      </div>

    </div>

  );

}